import { render, staticRenderFns } from "./NotificationCardForPathActivityComment.vue?vue&type=template&id=d48677b0&scoped=true&"
import script from "./NotificationCardForPathActivityComment.vue?vue&type=script&lang=js&"
export * from "./NotificationCardForPathActivityComment.vue?vue&type=script&lang=js&"
import style0 from "./NotificationCardForPathActivityComment.vue?vue&type=style&index=0&id=d48677b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d48677b0",
  null
  
)

export default component.exports